/**
 *
 * @param form
 * @return - An object containing which PII fields exist for the event. This will use both data from eventData
 * or from window.DDC.dataLayer.confirmation.
 * @example
 * {
 *  firstNameExists: true,
 *  lastNameExists: true,
 *  phoneExists: false,
 *  emailExists: true
 * }
 */
const getPIIExistence = (form, confirmation = {}) => {
	const pii = [
		'applicant.contact.email',
		'applicant.contact.firstName',
		'applicant.contact.lastName',
		'applicant.contact.phone',
		'applicant.contact.address.street',
		'contact.firstName',
		'contact.lastName',
		'contact.email',
		'contact.phone',
		'contact.address.street'
	];
	const fields = {};

	pii.forEach((info) => {
		const lookup = info
			.replace('applicant.', '')
			.replace('contact.', '')
			.replace('address.', '');
		const prop = `${lookup.replace('address.', '')}Exists`;
		const formFieldHasValue =
			form &&
			((form?.elements?.[info] && !!form.elements?.[info].value) ||
				(form?.elements?.[`${info}.sep`] &&
					!!form.elements?.[`${info}.sep`].value)); // formbuilder adds .sep to fields
		fields[prop] =
			fields[prop] || // If we don't have this then true entries will get overwritten
			(form && formFieldHasValue) ||
			(confirmation && !!confirmation[lookup]) ||
			false;
	});

	return fields;
};

export default getPIIExistence;
